module.exports = __webpack_public_path__ + "img/ywAward-c.1b699a20.png";